<template>
  <v-container class="px-12">
    <!-- Sección 1: Tipo de cambio -->
    <v-row class="my-12">
      <v-col cols="12" md="6">
        <h2 style="font-family: 'montserrat-bold'; font-size: 48px; line-height: normal;">
          Convierte tu dinero<br />
          al mejor <span class="textPrimary">tipo de cambio</span>
        </h2>
        <p style="font-family: 'montserrat-regular'; font-size: 16px; color: #555;">
          Realiza tus operaciones cambiarias de manera segura y eficiente,
          con tipos de cambio competitivos, procesos transparentes y soporte especializado.
        </p>
        <v-btn color="primary" :to="'/requirements'" rounded class="px-8">Empieza ahora</v-btn>
      </v-col>
      <v-col cols="12" md="6" class="d-flex justify-center align-center">
        <v-img
          src="@/assets/exchange-visual.svg"
          max-width="450"
          contain
          eager
          alt="Ilustración tipo de cambio"
        ></v-img>
      </v-col>
    </v-row>

    <!-- Sección 2: Factoraje / línea de crédito -->
    <v-row class="my-12" align="center">
      <v-col cols="12" md="6" class="d-flex justify-center align-center">
        <v-img
          src="@/assets/factoring-visual.svg"
          max-width="450"
          contain
          eager
          alt="Ilustración tipo de cambio"
        ></v-img>
      </v-col>
      <v-col cols="12" md="6">
        <h2 style="font-family: 'montserrat-bold'; font-size: 48px; line-height: normal;">
          Solicita el <span class="textPrimary">Factoraje</span><br />
          que tu empresa necesita
        </h2>
        <p style="font-family: 'montserrat-regular'; font-size: 16px; color: #555;">
          Obtén liquidez inmediata a través del adelanto de tus facturas y mantén el flujo de efectivo que tu negocio necesita para seguir creciendo.
        </p>
        <v-btn color="primary" :to="'/requirements'" rounded class="px-8">Conoce tu línea de crédito</v-btn>
      </v-col>
    </v-row>

    <!-- Sección 3: Agentes de IA -->
    <v-row class="my-12">
      <v-col cols="12" md="6">
        <h2 style="font-family: 'montserrat-bold'; font-size: 40px; line-height: normal;">
          Conoce los <span class="textPrimary">agentes de IA</span><br />
          que impulsarán el crecimiento de tu empresa
        </h2>
        <p style="font-family: 'montserrat-regular'; font-size: 16px; color: #555;">
          Descubre cómo los agentes de inteligencia artificial pueden automatizar tareas, mejorar la atención al cliente y ayudarte a tomar decisiones más inteligentes en tu empresa.
        </p>
        <v-btn color="primary" :to="'/ia-agents'" rounded class="px-8">Solicita tu agente aquí</v-btn>
      </v-col>
      <v-col cols="12" md="6" class="d-flex justify-center align-center">
        <v-img
          src="@/assets/ia-visual.svg"
          max-width="450"
          contain
          eager
          alt="Ilustración tipo de cambio"
        ></v-img>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'ExchangeDashboard',
};
</script>

<style>
.textPrimary {
  color: #0075B8;
}
</style>
